import { useCallback, useEffect, useRef } from 'react';

const EXCLUSIVE_DROPDOWN_EVENT = 'accountix:exclusive-dropdown-open';

interface DropdownEventDetail {
  id: string;
}

/**
 * Coordinates custom dropdowns that are owned by different components.
 * Native <select> controls are intentionally not part of this coordinator.
 */
export function useExclusiveDropdown(id: string, onClose: () => void) {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    const handleDropdownOpen = (event: Event) => {
      const detail = (event as CustomEvent<DropdownEventDetail>).detail;
      if (detail?.id !== id) onCloseRef.current();
    };

    window.addEventListener(EXCLUSIVE_DROPDOWN_EVENT, handleDropdownOpen);
    return () => window.removeEventListener(EXCLUSIVE_DROPDOWN_EVENT, handleDropdownOpen);
  }, [id]);

  return useCallback(() => {
    window.dispatchEvent(new CustomEvent<DropdownEventDetail>(EXCLUSIVE_DROPDOWN_EVENT, { detail: { id } }));
  }, [id]);
}
